import CollapseIcon from '@mdi/svg/svg/arrow-collapse.svg?react';
import ExpandIcon from '@mdi/svg/svg/arrow-expand.svg?react';
import { Flex, Grid, IconWithTooltip } from '@solinkcorp/solink-components';
import classNames from 'classnames';
import React, { useId } from 'react';
import { EventColoredCollapsibleSection } from '../EventColoredCollapsibleSection/EventColoredCollapsibleSection';
import EventExpandPopover from '../EventExpandPopover/EventExpandPopover';
import styles from './AiFindingsSection.module.sass';

export { styles as aiFindingsStyles };

interface AiFindingsSectionProps {
  eventColor: string;
  title: string;
  tooltip: string;
  summaryContent: React.ReactNode;
  expandedContent: React.ReactNode;
}

const AiFindingsSection: React.FC<AiFindingsSectionProps> = ({
  eventColor,
  title,
  tooltip,
  summaryContent,
  expandedContent,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const uniqueId = useId();
  const expandButtonId = `expand-ai-findings-${uniqueId}`;

  const toggleExpanded = () => setIsOpen(!isOpen);

  return (
    <EventColoredCollapsibleSection eventColor={eventColor}>
      <Grid alignItems="flex-end" justifyItems="flex-start" gridTemplateColumns="1fr auto">
        <span className={styles.title}>{title}</span>
        <span id={expandButtonId}>
          <IconWithTooltip
            key={isOpen ? 'collapse' : 'expand'}
            icon={isOpen ? CollapseIcon : ExpandIcon}
            iconSize={19}
            fill={isOpen ? eventColor : 'var(--color-white)'}
            title={tooltip}
            onClick={toggleExpanded}
            className={classNames(styles.expandButton, {
              [styles.expandButtonActive]: isOpen,
            })}
          />
          <EventExpandPopover
            isOpen={isOpen}
            togglePopover={toggleExpanded}
            popoverButtonId={expandButtonId}
            horizontalOffset={-1}
            verticalOffset={3}
          >
            <Flex>
              <div className={styles.entries}>{expandedContent}</div>
            </Flex>
          </EventExpandPopover>
        </span>
      </Grid>
      <Flex>
        <div className={styles.entries}>{summaryContent}</div>
      </Flex>
    </EventColoredCollapsibleSection>
  );
};

export default AiFindingsSection;
